<ion-header class="ion-no-border">
  <ion-toolbar color="primary">
    @let uinfo = detail().userInfo;
    @let uname = [uinfo.name, uinfo.surname, uinfo.second_surname].join(' ');
    <ion-title [subtitle]="uname">{{detail().company.name}}</ion-title>
    <ion-buttons slot="end">
      <!-- no implementat encara  [routerLink]="['notis']" -->
       @let unsIPE = unsignedEpis();
      <ion-button [class.ion-hide]="!unsIPE.length" id="bell-trigger">
        <ion-icon slot="icon-only" name="bell"></ion-icon>
      </ion-button>
      <ion-popover trigger="bell-trigger" triggerAction="click" style="--min-width:300px" #pop>
        <ng-template>
          <ion-header class="ion-no-border">
            <ion-toolbar color="light">
              <ion-title size="small" translate [translateParams]="{num:unsIPE.length}">indicadors.n_pendents</ion-title>
            </ion-toolbar>
          </ion-header>
          <ion-content class="ion-padding">
            @for ( delivery of unsignedDeliveries(); track delivery[0]) {
              <!--@let del = +delivery[0];-->
              @let epis = delivery[1];
              @let samp = epis[0];
              <ion-card color="light" style="background:var(--ion-color-secondary-tint)">
                <ion-card-header>{{ samp.sent | date:'longDate':'':'es' }}</ion-card-header>
                <ion-card-content>
                  <ul>
                    <li *ngFor="let ipe of epis">{{ ipe.company_protections_name }}</li>
                  </ul>
                </ion-card-content>
                <ion-button fill="clear" color="primary" (click)="requestSignature(samp);pop.dismiss()" 
                  translate>
                  treballadors.ipe.signatura
                  <ion-icon name="signature" slot="start"></ion-icon>
                </ion-button>
              </ion-card>
            }
          </ion-content>
        </ng-template>
      </ion-popover>

      <ion-button [routerLink]="['user']" [state]="uinfo">
        <ion-icon slot="icon-only" name="profile"></ion-icon>
      </ion-button>

      <ion-button appLandBot [hidden]="!detail().isPRL || view!='admin'">
        <ion-icon slot="icon-only" name="help-circle-outline"></ion-icon>
      </ion-button>

    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div id="dashboard-wrap">

    @let isPRL = view === 'admin';
    @let isFAC = view === 'facs';
    @if (isPRL) {
      <ion-card class="dashcard" id="riscos" button [routerLink]="['..', 'tabs', 'indicadors']">
        <ion-card-content>
          <img src="assets/riscos.svg">
        </ion-card-content>
        <ion-card-header>
          <ion-card-title translate>dashboard.riscos</ion-card-title>
          <ion-card-subtitle translate [translateParams]="{name: detail().company.name}">
            dashboard.sriscos
            <ion-icon name="fwd" color="primary" style="float:right;font-size:18px;"></ion-icon>
          </ion-card-subtitle>
        </ion-card-header>
      </ion-card>
    }

    <!-- Targeta per a Salut o Revisions -->
    <ion-card class="dashcard" id="salut" button [routerLink]="['..', 'tabs', isPRL ? 'revisions' : 'salut']">
      <ion-card-content>
        <img [src]="isPRL ? 'assets/salut.svg' : 'assets/salut.svg'">
      </ion-card-content>
      <ion-card-header>
        <ion-card-title>{{ isPRL ? ('dashboard.revisions' | translate) : ('dashboard.salut' | translate) }}</ion-card-title>
        <ion-card-subtitle>
          {{ isPRL ? ('dashboard.srevisions' | translate) : ('dashboard.ssalut' | translate) }}
          <ion-icon name="fwd" color="primary" style="float:right;font-size:18px;"></ion-icon>
        </ion-card-subtitle>
      </ion-card-header>
    </ion-card>

    <!-- Targeta per a Formació o Treballadors -->
    <ion-card class="dashcard" id="formacio" button [routerLink]="['..', 'tabs', isPRL ? 'treballadors' : 'formacio']">
      <ion-card-content>
        <img [src]="isPRL ? 'assets/formacio.svg' : 'assets/formacio.svg'">
      </ion-card-content>
      <ion-card-header>
        <ion-card-title>{{ isPRL ? ('dashboard.treballadors' | translate) : ('dashboard.formacio' | translate) }}</ion-card-title>
        <ion-card-subtitle>
          {{ isPRL ? ('dashboard.streballadors' | translate) : ('dashboard.sformacio' | translate) }}
          <ion-icon name="fwd" color="primary" style="float:right;font-size:18px;"></ion-icon>
        </ion-card-subtitle>
      </ion-card-header>
    </ion-card>

    <ion-card [class.half]="isPRL" class="dashcard" id="documents" button [routerLink]="['..', 'tabs', 'documents']">
      <ion-card-content>
        <img src="assets/documents.svg">
      </ion-card-content>
      <ion-card-header>
        <ion-card-title translate>dashboard.documents</ion-card-title>
        <ion-card-subtitle translate>
          dashboard.sdocuments
          <ion-icon name="fwd" color="primary" style="float:right;font-size:18px;"></ion-icon>
        </ion-card-subtitle>
      </ion-card-header>
    </ion-card>

    

    @if (isPRL) {
      <ion-card class="half dashcard" id="avisans" button [routerLink]="['..', 'tabs', 'avisans']">
      <ion-card-content>
        <img src="assets/avisans.svg">
      </ion-card-content>
      <ion-card-header>
        <ion-card-title translate>dashboard.avisans</ion-card-title>
        <ion-card-subtitle >
          {{ (isPRL?'dashboard.savisansP':'dashboard.savisans') | translate }}
          <ion-icon name="fwd" color="primary" style="float:right;font-size:18px;"></ion-icon>
        </ion-card-subtitle>
      </ion-card-header>
    </ion-card>

      <ion-card class="half dashcard" button [routerLink]="['..', 'tabs','factures']">
        <ion-card-header>
          <ion-card-title translate style="text-align:center" translate>factures.titol</ion-card-title>
        </ion-card-header>
      </ion-card>

      <ion-card class="half dashcard" button href="https://intranet.previntegral.com" target="_blank">
        <ion-card-header>
          <ion-card-title translate style="text-align:center" translate>dashboard.legacy_app</ion-card-title>
        </ion-card-header>
      </ion-card>
    } @else if (isFAC) {
      <ion-card class="dashcard" button [routerLink]="['..', 'tabs','factures']">
        <ion-card-header>
          <ion-card-title translate style="text-align:center" translate>factures.titol</ion-card-title>
        </ion-card-header>
      </ion-card>
    }

  </div>

  

  <ion-note size="small" style="margin-left:10px"> V1.48/07.26 </ion-note>
  
</ion-content>
